import { Controller } from "@hotwired/stimulus"
import IMask from "imask"

export default class extends Controller {
  static values = {
    scale: { type: Number, default: 2 },
    thousandsSeparator: { type: String, default: " " },
    min: { type: Number, default: 0 }
  }

  connect() {
    this.mask = IMask(this.element, {
      mask: Number,
      scale: this.scaleValue,
      thousandsSeparator: this.thousandsSeparatorValue,
      radix: ".",
      mapToRadix: [","],
      min: this.minValue,
      lazy: false // show mask immediately
    })

    // Store unmasked value before form submission
    this.element.form?.addEventListener("submit", this.handleSubmit.bind(this))
  }

  handleSubmit(event) {
    // Replace the masked value with unmasked number
    this.element.value = this.mask.unmaskedValue
  }

  disconnect() {
    this.element.form?.removeEventListener(
      "submit",
      this.handleSubmit.bind(this)
    )
    if (this.mask) {
      this.mask.destroy()
    }
  }
}
